import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { withClientId } from 'hocs';
import { accumulateZonesBySite, listSites } from 'redux/modules/model/site';
import { getBlock } from 'redux/modules/model/attendance';
import {
	accumulatedZonesBySiteSelector,
	blockDetailsSelector,
	sitesInfoSelector,
} from 'redux/selectors';
import { bem, convertFromIsoTime, convertToIsoTime } from 'utils/helpers';

import { DatePicker, Select } from 'elements';

import './index.scss';

const em = (e, m) => bem('block-details', e, m);

let clearedEditingState = false;

class BlockDetails extends Component {
	clearEditingState = () => {
		const { editingStateCallback } = this.props;
		this.setState(() => {
			const editingState = {
				startTime: null,
				endTime: null,
				siteId: null,
				zoneId: null,
			};
			editingStateCallback(editingState);
			return { editing: editingState };
		});
	};

	updateEditingState = (key, value) => {
		const { editingStateCallback } = this.props;
		this.setState(state => {
			const editingState = {
				...state.editing,
				[key]: value,
			};
			editingStateCallback(editingState);
			return { editing: editingState };
		});
	};

	componentDidMount = () => {
		const {
			clientId,
			scheduleId,
			blockId,
			getBlock,
			listSites,
		} = this.props;
		this.clearEditingState();
		getBlock({ clientId, scheduleId, blockId });
		listSites({ clientId });
	};

	componentDidUpdate = () => {
		const {
			clientId,
			edit,
			sites,
			accumulateZonesBySite,
			blockDetails,
		} = this.props;
		sites.forEach(site =>
			accumulateZonesBySite({ clientId, siteId: site.siteId }),
		);
		if (edit) {
			['startTime', 'endTime', 'siteId', 'zoneId'].forEach(key => {
				if (this.state.editing[key] == null && blockDetails) {
					this.updateEditingState(key, blockDetails[key]);
					clearedEditingState = false;
				}
			});
		} else {
			if (!clearedEditingState) {
				this.clearEditingState();
				clearedEditingState = true;
			}
		}
	};

	render = () => {
		const {
			edit,
			accumulatedZonesBySite,
			blockDetails,
			sites,
			values,
		} = this.props;
		const dateFormat = 'DD/MM/YYYY HH:mm';
		const fields = blockDetails && {
			endTime: blockDetails.endTime,
			siteDescription: (() => {
				const matchedSite = sites.find(
					site => site.siteId === blockDetails.siteId,
				);
				return matchedSite && matchedSite.description;
			})(),
			siteId: blockDetails.siteId,
			startTime: blockDetails.startTime,
			zoneId: blockDetails.zoneId,
			zoneName: (() => {
				const matchedZone =
					accumulatedZonesBySite[blockDetails.siteId] &&
					accumulatedZonesBySite[blockDetails.siteId].find(
						zone => zone.zoneId === blockDetails.zoneId,
					);
				return matchedZone && matchedZone.name;
			})(),
		};
		return (
			<table className={em('table')}>
				<tbody>
					<tr>
						<th className={em('table-header')}>Start</th>
						<td>
							{edit
								? fields && (
										<DatePicker
											showTimevalue={
												values.startTime
													? moment(values.startTime)
													: values.startTime
											}
											defaultValue={moment(
												fields.startTime,
											)}
											allowClear={false}
											format={dateFormat}
											onChange={value => {
												this.updateEditingState(
													'startTime',
													value.format(
														'YYYY-MM-DD[T]HH:mm:ss',
													),
												);
											}}
										/>
								  )
								: fields &&
								  moment(fields.startTime).format(dateFormat)}
						</td>
					</tr>
					<tr>
						<th className={em('table-header')}>End</th>
						<td>
							{edit
								? fields && (
										<DatePicker
											showTime
											value={
												values.endTime
													? moment(values.endTime)
													: values.endTime
											}
											defaultValue={moment(
												fields.endTime,
											)}
											allowClear={false}
											format={dateFormat}
											onChange={value => {
												this.updateEditingState(
													'endTime',
													value.format(
														'YYYY-MM-DD[T]HH:mm:ss',
													),
												);
											}}
										/>
								  )
								: fields &&
								  moment(fields.endTime).format(dateFormat)}
						</td>
					</tr>
					<tr>
						<th className={em('table-header')}>Site</th>
						<td>
							{edit
								? fields && (
										<Select
											className={em('site-selector')}
											defaultValue={fields.siteId}
											onChange={value => {
												this.updateEditingState(
													'siteId',
													value,
												);
											}}
											// showSearch
											disabled
										>
											{sites &&
												sites.map(site => (
													<Select.Option
														key={site.siteId}
														value={site.siteId}
													>
														{site.description}
													</Select.Option>
												))}
										</Select>
								  )
								: fields && fields.siteDescription}
						</td>
					</tr>
					<tr>
						<th className={em('table-header')}>Zone</th>
						<td>
							{edit
								? fields && (
										<Select
											className={em('zone-selector')}
											defaultValue={fields.zoneId}
											onChange={value => {
												this.updateEditingState(
													'zoneId',
													value,
												);
											}}
											// showSearch
										>
											{accumulatedZonesBySite[
												fields.siteId
											] &&
												accumulatedZonesBySite[
													fields.siteId
												].map(zone => (
													<Select.Option
														key={zone.zoneId}
														value={zone.zoneId}
													>
														{zone.name}
													</Select.Option>
												))}
										</Select>
								  )
								: fields && fields.zoneName}
						</td>
					</tr>
				</tbody>
			</table>
		);
	};
}

export const selectors = createStructuredSelector({
	accumulatedZonesBySite: accumulatedZonesBySiteSelector,
	blockDetails: blockDetailsSelector,
	sites: sitesInfoSelector,
});
export const actions = {
	accumulateZonesBySite,
	getBlock,
	listSites,
};
export default compose(
	withClientId,
	connect(
		selectors,
		actions,
	),
)(BlockDetails);



// WEBPACK FOOTER //
// ./src/pages/attendance/attendance-schedule-detail/components/block-info/components/block-details/index.js